export default function Loading({ label = "Lighting up today's lesson..." }) {
    return (
        <div className="flex flex-col items-center justify-center py-20 gap-4" data-testid="loading-state">
            <div className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-full bg-coral animate-bounce" style={{ animationDelay: "0ms" }} />
                <span className="w-3 h-3 rounded-full bg-sun animate-bounce" style={{ animationDelay: "150ms" }} />
                <span className="w-3 h-3 rounded-full bg-mint animate-bounce" style={{ animationDelay: "300ms" }} />
                <span className="w-3 h-3 rounded-full bg-sky animate-bounce" style={{ animationDelay: "450ms" }} />
            </div>
            <p className="font-heading font-semibold text-ink/70">{label}</p>
        </div>
    );
}
